import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import useLanguageChange from "../../hooks/useLanguageChange";
import { setIsAppDownloadModalOpenForMeasurement, setIsFirstStepCompletedOfDownloadApp } from "../../reducers/measurement-reducer";
import { LogFirebase } from "../../services/firestore";
import googleEvent from "../../services/googleEvent";
import { disconnectAndLaunchApp, openStore } from "../Twilio/ScreenShare/ScreenShareUtils";
import { EVENT_NAME } from "../../constants/GTagConstants";
import CenterModal from "../UI/Modal/CenterModal";

const MeasurementAppRequiredModal = () => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();
    const { isAppDownloadModalOpenForMeasurement, isFirstStepCompletedOfDownloadApp } = useSelector((state) => state.measurement);

    const handleCloseAppDownloadModal = () => {
        dispatch(setIsAppDownloadModalOpenForMeasurement(false));
        dispatch(setIsFirstStepCompletedOfDownloadApp(false));
        LogFirebase("MwebMeasurement ", "popup", "Closed");
        googleEvent.logEvent(EVENT_NAME.MWEB_MEASUREMENT_POPUP_CLOSED);
    };

    const header = (
        <>
            <h5 className='modal-title'></h5>
            <button type='button' className='btn-close' aria-label='Close' onClick={handleCloseAppDownloadModal}>
                <span className='btn-icon icon-close-light'></span>
            </button>
        </>
    );

    const body = (
        <div className='app-download-require' data-testid='measurement-requireModel'>
            <h3>{localisedValues["app_to_support_ar_measurement"]}</h3>
            <div className='app-require-nav'>
                <ul>
                    <li className={clsx(isFirstStepCompletedOfDownloadApp ? "complete" : "active")}>
                        <div className='step-count-box'>
                            <div className='step-count'>
                                <div className='step-count-text'>1</div>
                            </div>
                            <div className='step-text'>{localisedValues["download_app"]}</div>
                        </div>
                    </li>
                    <li className={clsx(isFirstStepCompletedOfDownloadApp && "active")}>
                        <div className='step-count-box'>
                            <div className='step-count'>
                                <div className='step-count-text'>2</div>
                            </div>
                            <div className='step-text'>{localisedValues["launch_app"]}</div>
                        </div>
                    </li>
                </ul>
            </div>
            <div className='app-download-require-content'>
                <div className={clsx("app-download-require-box", !isFirstStepCompletedOfDownloadApp && "active")}>
                    <h4>
                        {localisedValues["step_one"]}: {localisedValues["download_app"]}
                    </h4>
                    <p>{localisedValues["ar_measurement_description_step1"]}</p>
                    <div className='step-button-foot'>
                        <div className='button button-full-width'>
                            <button className='btn default-btn-primary' onClick={openStore}>
                                <span className='btn-text'>
                                    {localisedValues["step_one"]}: {localisedValues["click_to_download_app"]}
                                </span>
                            </button>
                        </div>
                    </div>
                    <div className='nextprev-button-foot'>
                        <p>{localisedValues["go_to_Step_2"]}</p>
                        <div className='button button-full-width'>
                            <button
                                className='btn default-btn-primary btn-with-icon right-icon app-download-next-button'
                                onClick={() => dispatch(setIsFirstStepCompletedOfDownloadApp(true))}
                            >
                                <span className='btn-text'>{`${localisedValues["next_lable"]} (${localisedValues["step_two"]})`} </span>
                                <span className='btn-icon icon-right-arrow'></span>
                            </button>
                        </div>
                    </div>
                </div>
                <div className={clsx("app-download-require-box", isFirstStepCompletedOfDownloadApp && "active")}>
                    <h4>
                        {localisedValues["step_two"]}: {localisedValues["rejoin_the_call_in_app"]}
                    </h4>
                    <p>{localisedValues["ar_measurement_description_step2"]}</p>
                    <div className='step-button-foot'>
                        <div className='button button-full-width'>
                            <button className='btn default-btn-primary' onClick={() => disconnectAndLaunchApp("measurement")}>
                                <span className='btn-text'>
                                    {localisedValues["step_two"]}: {localisedValues["rejoin_call_in_app"]}
                                </span>
                            </button>
                        </div>
                        <p>{localisedValues["disconnect_the_call_in_browser"]}</p>
                    </div>
                    <div className='nextprev-button-foot'>
                        <div className='button button-full-width'>
                            <button
                                className='btn btn-default-outline btn-with-icon app-download-previous-button'
                                onClick={() => dispatch(setIsFirstStepCompletedOfDownloadApp(false))}
                            >
                                <span className='btn-icon icon-left-arrow'></span>
                                <span className='btn-text'>{localisedValues["back_btn_lable"]}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <CenterModal
            showModal={isAppDownloadModalOpenForMeasurement}
            closeModal={handleCloseAppDownloadModal}
            modalClass='default-modal modal-medium app-download-require-modal'
            className='modal-dialog-centered'
            header={header}
            body={body}
            backdrop={"static"}
        />
    );
};

export default MeasurementAppRequiredModal;
